import Grid from '@mui/material/Grid2';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useFormContext } from 'react-hook-form-mui';
import DataContainer from '../../../../Utilities/DataContainer';
import RenderSelectField from '../../../../Utilities/Forms/RenderSelectField';
import RenderTextField from '../../../../Utilities/Forms/RenderTextField';
import ValidatedSelectElement from '../../../../Utilities/Forms/ValidatedSelectElement';
import ValidatedTextField from '../../../../Utilities/Forms/ValidatedTextField';
import monthDropdown from '../../../../Utilities/Constants/MonthDropdown';
import yesNoDropdown from '../../../../Utilities/Constants/YesNoDropdown';

//WS-03-A-17

interface IProps {
    isReadOnly: boolean
    isResidential: boolean
}
export default function TravelPlanIncentives({ isReadOnly, isResidential }: IProps) {
    const { watch } = useFormContext();
    const formValues = watch();
    const hasValues = (fields: string[]) => fields.some(field => {
        const value = formValues[field];
        return value !== null && value !== undefined && value !== '';
    }) || !isReadOnly;

    return (
        <>
            <Grid container alignItems="flex-start">
                <Grid size={6} container>
                    {!isResidential && hasValues(["seasonTicketLoan", "seasonTicketLoanMonth", "seasonTicketLoanYear"]) && (
                        <Grid container size={12}>
                            <DataContainer title={"Public Transport Season Ticket Loans"}>
                                <Stack spacing={1}>
                                    <RenderSelectField label={'Does the site offer staff public transport season ticket loans?'} name={'seasonTicketLoan'} readOnly={isReadOnly} options={yesNoDropdown} />
                                    {formValues.seasonTicketLoan === 'Y' && (
                                        <>
                                            <Grid size={12}>
                                                <Typography variant={"body2"}>Date Implemented</Typography>
                                            </Grid>
                                            <Stack direction="row" spacing={1}>
                                                <Grid size={6}>
                                                    <ValidatedSelectElement name={'seasonTicketLoanMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                                </Grid>
                                                <Grid size={6}>
                                                    <ValidatedTextField name={'seasonTicketLoanYear'} readOnly={isReadOnly} />
                                                </Grid>
                                            </Stack>
                                        </>
                                    )}
                                </Stack>
                            </DataContainer>
                        </Grid>
                    )}

                    {!isResidential && hasValues(["cyclingIncentives", "cyclingIncentivesMonth", "cyclingIncentivesYear"]) && (
                        <Grid container size={12}>
                            <DataContainer title={"Cycling Incentives"}>
                                <Stack spacing={1}>
                                    <RenderSelectField label={'Does the site offer staff financial incentives for cycling?'} name={'cyclingIncentives'} readOnly={isReadOnly} options={yesNoDropdown} />
                                    {formValues.cyclingIncentives === 'Y' && (
                                        <>
                                            <Grid size={12}>
                                                <Typography variant={"body2"}>Date Implemented</Typography>
                                            </Grid>
                                            <Stack direction="row" spacing={1}>
                                                <Grid size={6}>
                                                    <ValidatedSelectElement name={'cyclingIncentivesMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                                </Grid>
                                                <Grid size={6}>
                                                    <ValidatedTextField name={'cyclingIncentivesYear'} readOnly={isReadOnly} />
                                                </Grid>
                                            </Stack>
                                        </>
                                    )}
                                </Stack>
                            </DataContainer>
                        </Grid>
                    )}

                    {isResidential && hasValues(["travelVouchers", "travelVouchersMonth", "travelVouchersYear", "busVoucher", "busVoucherValue", "trainVoucher", "trainVoucherValue", "bikeVoucher", "bikeVoucherValue", "cycleTraining", "cycleTrainingValue", "otherVoucher", "otherVoucherValue", "otherVoucherText"]) && (
                        <Grid container size={12}>
                            <DataContainer title={"Travel Voucher Details"}>
                                <Stack spacing={1}>
                                    <Grid size={12}>
                                        <RenderSelectField label={"Are residents offered 'sustainable travel vouchers' that can be put towards one or more options?"} name={'travelVouchers'} readOnly={isReadOnly} options={yesNoDropdown} />
                                        <Grid size={12}>
                                            <Typography variant={"body2"}>Date Implemented</Typography>
                                        </Grid>
                                        <Stack direction="row" spacing={1}>
                                            <Grid size={6}>
                                                <ValidatedSelectElement name={'travelVouchersMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                            </Grid>
                                            <Grid size={6}>
                                                <ValidatedTextField name={'travelVouchersYear'} readOnly={isReadOnly} />
                                            </Grid>
                                        </Stack>

                                    </Grid>
                                    <Typography variant={'body1'}>Which of the following options are available?</Typography>
                                    <Grid size={12}>
                                        <Stack direction="row" spacing={1}>
                                            <Grid size={6}>
                                                <RenderSelectField label={'Bus taster/season ticket'} name={'busVoucher'} readOnly={isReadOnly} options={yesNoDropdown} labelSize={12} inputSize={12} />
                                            </Grid>
                                            <Grid size={6}>
                                                <RenderTextField label={'Value of voucher per household/dwelling'} name={'busVoucherValue'} readOnly={isReadOnly} labelSize={12} inputSize={12} />
                                            </Grid>
                                        </Stack>

                                        <Stack direction="row" spacing={1}>
                                            <Grid size={6}>
                                                <RenderSelectField label={'Train taster/season ticket'} name={'trainVoucher'} readOnly={isReadOnly} options={yesNoDropdown} labelSize={12} inputSize={12} />
                                            </Grid>
                                            <Grid size={6}>
                                                <RenderTextField label={'Value of voucher per household/dwelling'} name={'trainVoucherValue'} readOnly={isReadOnly} labelSize={12} inputSize={12} />
                                            </Grid>
                                        </Stack>

                                        <Stack direction="row" spacing={1}>
                                            <Grid size={6}>
                                                <RenderSelectField label={'Purchase of a bicycle and/or cycling equipment'} name={'bikeVoucher'} readOnly={isReadOnly} options={yesNoDropdown} labelSize={12} inputSize={12} />
                                            </Grid>
                                            <Grid size={6}>
                                                <RenderTextField label={'Value of voucher per household/dwelling'} name={'bikeVoucherValue'} readOnly={isReadOnly} labelSize={12} inputSize={12} />
                                            </Grid>
                                        </Stack>

                                        <Stack direction="row" spacing={1}>
                                            <Grid size={6}>
                                                <RenderSelectField label={'Cycle training'} name={'cycleTraining'} readOnly={isReadOnly} options={yesNoDropdown} labelSize={12} inputSize={12} />
                                            </Grid>
                                            <Grid size={6}>
                                                <RenderTextField label={'Value of voucher per household/dwelling'} name={'cycleTrainingValue'} readOnly={isReadOnly} labelSize={12} inputSize={12} />
                                            </Grid>
                                        </Stack>

                                        <Stack direction="row" spacing={1}>
                                            <Grid size={6}>
                                                <RenderSelectField label={'Other (specify)'} name={'otherVoucher'} readOnly={isReadOnly} options={yesNoDropdown} labelSize={12} inputSize={12} />
                                            </Grid>
                                            <Grid size={6}>
                                                <RenderTextField label={'Value of voucher per household/dwelling'} name={'otherVoucherValue'} readOnly={isReadOnly} labelSize={12} inputSize={12} />
                                            </Grid>
                                        </Stack>
                                        <RenderTextField label={''} name={'otherVoucherText'} readOnly={isReadOnly} />
                                    </Grid>
                                </Stack>
                            </DataContainer>
                        </Grid>
                    )}
                </Grid>

                <Grid size={6} container>
                    <Grid container size={12} >
                        <DataContainer title={"Additional Comments"}>
                            <RenderTextField label={'Specify details of all Travel Plan elements identified in this section, along with any other incentive features not already covered.'} name={'incentivesComments'} readOnly={isReadOnly} multiLine={true} rows={4} labelSize={12} inputSize={12} alwaysShow={true} />
                        </DataContainer>
                    </Grid>
                </Grid>

            </Grid>
        </>
    );
}
